import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    checkedClass: { type: String, default: "tw-border-black tw-ring-2 tw-ring-black" }
  }

  connect() {
    this.update()
  }

  update(_event) {
    // find all radios in this group
    this.element.querySelectorAll('input[type="radio"][name]')
      .forEach((input) => {
        const label = input.closest("label")
        if (!label) return

        if (input.checked) {
          label.classList.add(...this.checkedClassValue.split(" "))
        } else {
          label.classList.remove(...this.checkedClassValue.split(" "))
        }
      })
  }
}
